// Exports
export default {
	"chatBlock": "chatBlock_eJlGt",
	"visible": "visible_Ly4ZH",
	"spinWrapper": "spinWrapper_AO6pe",
	"spin": "spin_Bfxlj",
	"chatClose": "chatClose_7oWIM"
};
